import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import bCategoryItem from "./category-item";
import {
  deleteStatus,
  displayLargeImage,
  displayRemoveAlert,
  formUpdateData,
  formUpdateStatus,
  imageUploadStatus,
  largeImageStatus,
  updateFormInfo,
} from "../../redux/slice/formUpdateSlice";
import AddUpdateForm from "./add-update-form";
import { updateMessage } from "../../redux/slice/toastSlice";
import AppToast from "../../components/appToast";
import AppLodingBar from "../../components/loader";
import { changeStatus } from "../../redux/slice/loaderSlice";
import CategoryItem from "./category-item";
import { listAction } from "../../network/store/action/CategoryResponseAction";
import DeleteBanner from "../banners/crudOperations/deleteBanner";
import { useIsFranchisLogin } from "../../utils/userRoles";
import { consoleLog } from "../../utils/log-utils";
import FullImageView from "../../components/full-image";

function Category() {
  const dispatch = useDispatch();

  // list of items
  const [resultList, setResultList] = useState([]);
  const showRequestForm = useSelector(formUpdateStatus);
  const showDeleteAlert=useSelector(deleteStatus);
  // progress Dialog
  const [isLoading, setIsLoading] = useState(false);

  const [filterList, setFilterList] = useState([]);
  const [searchVal, setSearchVal] = useState("");

  const imageUpload = useSelector(imageUploadStatus);
  const formData = useSelector(formUpdateData);
  const displayLargeImage = useSelector(largeImageStatus);
  const [isProductUpdate, setIsProductUpdate] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    await dispatch(
      listAction(
        {
          secId: "",
        },
        dispatch
      )
    ).then((reponse) => {
      setFilterList([]);

      if (reponse.result) {
        setResultList(reponse.result);
      } else {
        setResultList([]);
      }
    });
  };

  function handleSearchClick(e) {
    const searchTerm = e.target.value;
    setSearchVal(searchTerm);
    
    consoleLog("search Value", e.target.value)
    if (searchTerm === "") {
      setResultList(resultList);
      setFilterList([]);
    } else {
      const filterBySearch = resultList.filter((item) => {
        if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
          return item;
        }
      });
      setFilterList(filterBySearch);
    }
  }

  const onSubmit = () => {
    dispatch(changeStatus(false));
    dispatch(updateFormInfo({ displayForm: false, formData: {} }));
    dispatch(
      updateMessage({
        display: true,
        message: "Record updated",
      })
    );
    setResultList([]);
    setSearchVal("");
    setFilterList([]);

    loadData();
  };

  return (
    <>
      {showRequestForm && (
        <AddUpdateForm
          onSubmit={() => {
            onSubmit();
          }}
        />
      )}
      {showDeleteAlert && (
        <DeleteBanner 
          onSubmit={() => {
            onSubmit();
          }}
        />
      )}
      {displayLargeImage && (
        <>
          <FullImageView
            product={formData}
            onCancelClick={(reloadStatus) => {
              setIsProductUpdate(reloadStatus);
            }}
          />
        </>
      )}

      <main className="container-fluid dashboard">
        <div className="row m-3">
          <div className="row justify-content-around tble">
            <div className="col-6">
              <h3 className="dashboard-title">Categories</h3>
            </div>
            <div className="mr-auto col-6 text-end">
              {
                !useIsFranchisLogin() && <>
                 <button
                type="button"
                className="mr-auto btn add-button-color"
                onClick={() => {
                  dispatch(
                    updateFormInfo({
                      displayForm: true,
                      formData: {},
                    })
                  );
                }}
              >
                + Add Category
              </button>
                </>
              }
              
            </div>
          </div>
        </div>
        <div className="row m-3">
          <div className="col-12 col-md-3">
            <div className="form-group">
              <label>Search</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={searchVal}
                placeholder="Enter Category name"
                onChange={(e) => handleSearchClick(e)}
              />
            </div>
          </div>

          <div className="col-12 card-1 h-scroll">
            <table className="table table-hover align-middle">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">Id</th>
                  <th scope="col">Image</th>
                  <th scope="col">Category Name</th>
                  
                  {
                !useIsFranchisLogin() && <>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
                </>
                }
                  
                </tr>
              </thead>
              {searchVal === "" && resultList && resultList.length > 0 ? (
                <tbody>
                  {resultList.map((item, i) => {
                    return <CategoryItem item={item} key={item.id} />;
                  })}
                </tbody>
              ) : filterList.length > 0 ? (
                <tbody>
                  {filterList.map((item, i) => {
                    return <CategoryItem item={item} key={item.id} />;
                  })}
                </tbody>
              ) : (
                <p>No Data found</p>
              )}
            </table>
          </div>
        </div>
      </main>
    </>
  );
}

export default Category;
